module.exports = __webpack_public_path__ + "static/media/MyListLabelHandle.97412779.svg";